import React from 'react';

interface PriceLineRowProps {
  label: string;
  detail?: string;
  amount: string;
  compact?: boolean;
  included?: boolean;
  last?: boolean;
}

/**
 * Eine Positionszeile im Angebotsschema: Bezeichnung links,
 * Betrag rechts — wie eine Stückliste, nicht wie eine Punktlinie.
 */
export default function PriceLineRow({
  label,
  detail,
  amount,
  compact = false,
  included = false,
}: PriceLineRowProps) {
  return (
    <div className={`sv-spec-row${compact ? ' is-compact' : ''}`}>
      <dt className="sv-spec-label">
        <span className="sv-spec-name">{label}</span>
        {detail ? <span className="sv-spec-detail">{detail}</span> : null}
      </dt>
      <dd className={`sv-spec-amount${included ? ' is-included' : ''}`}>
        {amount}
      </dd>
    </div>
  );
}
